export default __webpack_public_path__ + "3e4b7f31628672699bcaf5ccdf544b08.svg";